import AWSPortOpeningRule from '../../entities/AWSPortOpeningRule';

export default class UpdateAWSPortOpeningRequestRule {

	id!: number;

	action!: string;

	operation!: string;

	description!: string;

	sourceIPs!: string;

	destinationIPs!: string;

    destinationURLs!: string;

	protocol!: string;

	region!: string;

	destinationPorts!: string;

	trafficDirection!: string;

	ruleName!: string;

	constructor(rule: AWSPortOpeningRule) {
		Object.assign(this, rule);
		this.action = rule.action?.name;
		this.operation = rule.operation?.name;
		this.region = rule.region?.name;
		this.ruleName = rule.name;
	}

}